import useOutsideClickHandler from '@/hooks/useClickOutside';
import styles from './modal.module.scss';
import XmarkIcon from '@/assets/icons/xmark.svg?react';
import { FC, ReactNode } from 'react';

interface ModalProps {
  children: ReactNode;
  title?: string;
  isOpen: boolean;
  closeOnClickOutside?: boolean;
  size?: 'medium' | 'large' | 'wide';
  onClose?: () => void;
}

const Modal: FC<ModalProps> = ({
  children,
  title,
  isOpen,
  onClose,
  closeOnClickOutside = true,
  size = 'medium',
}) => {
  const isCloseable = !!onClose;
  const closePopover = () => {
    if (isCloseable) {
      onClose();
    }
  };
  const modalRef = useOutsideClickHandler<HTMLDivElement>(
    closePopover,
    closeOnClickOutside && isOpen
  );

  if (!isOpen) return null;

  return (
    <>
      <div ref={modalRef} className={styles['modal']} data-size={size}>
        <div className={styles['modal-header']}>
          {title && <h2>{title}</h2>}
          {isCloseable && (
            <XmarkIcon
              className={styles['close-xmark']}
              onClick={closePopover}
            />
          )}
        </div>

        <div className={styles['modal-content']}>{children}</div>
      </div>

      <div className={styles['modal-backdrop']}></div>
    </>
  );
};

export default Modal;
